"use client";

import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react";

type WelcomeModalContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const WelcomeModalContext = createContext<WelcomeModalContextValue | null>(null);

export function WelcomeModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <WelcomeModalContext.Provider value={{ isOpen, open, close }}>
      {children}
    </WelcomeModalContext.Provider>
  );
}

export function useWelcomeModal(): WelcomeModalContextValue {
  const ctx = useContext(WelcomeModalContext);
  if (!ctx) {
    throw new Error("useWelcomeModal must be used within WelcomeModalProvider");
  }
  return ctx;
}
